module.exports = __webpack_public_path__ + "img/integral_2.d870d004.png";